import SelectInputForm from '@repo/ui/components/forms/SelectInputForm';
import PlusIcon from '@repo/ui/components/icons/popups/PlusIcon';

interface Props {
    openModal: () => void;
    options: [];
    placeholder?: string;
    label?: string;
    name: string;
    title?: string;
    className?: string;
}

export default function AddService({ openModal, options, label, name, placeholder, title, className }: Props) {
    return (
        <div className={className}>
            <SelectInputForm
                label={label}
                placeholder={placeholder}
                className="[&>input]:text-end [&>input]:placeholder:text-end"
                name={name}
                options={options}
            />
            <button onClick={openModal} className="flex gap-1 mt-3">
                <PlusIcon className="text-green-400" />
                <p className="md:text-[16px] text-[14px]"> {title} </p>
            </button>
        </div>
    );
}
